import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { UserServiceResources as us } from 'se-resource-types'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root'
})
export class AuthSessionService {

  constructor(
    private api: UserServiceApiService,
  ) { }

  public find(): Observable<us.AuthSession> {
    const url = 'auth_session'

    return this.api.get<us.AuthSession>(url).pipe(
      first(),
      map(r => r?.result)
    )
  }
}
